import http from '../_http'

const schedule = {
  //default
  listSchedule: (m) => { return http.post(`manager/wmds/schedule/list`, m); },
  detailSchedule: (m) => { return http.get(`manager/wmds/schedule/${m.id}`); },

  //crud
  insertSchedule: (m) => { return http.post(`manager/wmds/schedule`, m); },
  updateSchedule: (m) => { return http.put(`manager/wmds/schedule`, m); },
  deleteSchedule: (m) => { return http.delete(`manager/wmds/schedule/${m.id}`); },

  //start
  startSchedule: (m) => { return http.get(`manager/wmds/schedule/start/${m.id}`, m); },

  //delay
  delaySchedule: (m) => { return http.get(`manager/wmds/schedule/delay/${m.id}`, m); },
}

export default schedule

export { schedule }